"use client";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import styles from "./CookieBanner.module.scss";

const CONSENT_KEY = "uhp_banner_dismissed";

const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // sessionStorage clears on new browser session — banner reappears each new session
    if (!sessionStorage.getItem(CONSENT_KEY)) setVisible(true);
  }, []);

  const handleDismiss = () => {
    sessionStorage.setItem(CONSENT_KEY, "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.banner}
        role="region"
        aria-label="Cookie consent notice"
        aria-live="polite"
      >
        <div className={styles.body}>
          <h4 className={styles.title}>Notice</h4>
          <p className={styles.text}>
            We use cookies and similar tools to make your use of this website
            easy and to keep it working properly. We may share data about you
            and how you use the site with third parties, such as analytics and
            marketing partners. Learn more in our{" "}
            <Link href="/legal/privacy-policy" className={styles.link}>
              Privacy Policy
            </Link>{" "}
            and{" "}
            <Link href="/legal/terms-and-conditions" className={styles.link}>
              Terms of Use
            </Link>
            . By continuing to use the site, you agree to this.
          </p>
        </div>
        <button
          className={styles.closeBtn}
          onClick={handleDismiss}
          aria-label="Close cookie notice"
        >
          &#x2715;
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
